<template>
    <path
        d="M4.90658 8.52696C2.88291 8.52696 1.07227 6.82282 1.07227 4.69265C1.07227 2.56247 2.88291 0.964844 4.90658 0.964844C6.93025 0.964844 8.63439 2.66898 8.63439 4.69265C8.63439 6.82282 6.93025 8.52696 4.90658 8.52696Z"
        stroke-width="1.3"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
    <path
        d="M6.61176 18.7486H3.09697C2.03188 18.7486 0.966797 17.8965 0.966797 16.8314V13.3166C0.966797 12.145 1.92538 11.293 3.09697 11.293H6.61176C7.67685 11.293 8.63543 12.145 8.63543 13.3166V16.8314C8.63543 17.79 7.67685 18.7486 6.61176 18.7486Z"
        stroke-width="1.3"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
    <path
        d="M16.9428 18.7518H13.428C12.3629 18.7518 11.4043 17.8997 11.4043 16.7281V2.98851C11.4043 1.92342 12.2564 0.964844 13.428 0.964844H16.9428C18.0078 0.964844 18.9664 1.81691 18.9664 2.98851V16.7281C18.9664 17.7932 18.0078 18.7518 16.9428 18.7518Z"
        stroke-width="1.3"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</template>
